// extracted by mini-css-extract-plugin
module.exports = {"introTitle":"Experience_introTitle__15KE2","experiencesContainer":"Experience_experiencesContainer__3Uzhn","check":"Experience_check__1UxKW"};